import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewDocumentsModelComponent } from '../review-documents-model/review-documents-model.component';
import { ReviewContributorsModelComponent } from '../review-contributors-model/review-contributors-model.component';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { ExtendedFormControlsComponent } from '../../extended-form-controls/extended-form-controls.component';
import { ReviewService } from 'src/app/services/common/review.service';
import { CommonService } from 'src/app/services/common.service';
import { DateObject, DocumentUploadFile, Document_Upload_File } from 'src/app/models/common';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { serviceConstants } from 'src/app/constants/service.constants';

@Component({
  selector: 'app-setup-review-model',
  templateUrl: './setup-review-model.component.html',
  styleUrls: ['./setup-review-model.component.scss']
})
export class SetupReviewModelComponent  implements OnInit {

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  @Input() public Content: any;
  content: any;
  appId: any;
  ReviewId: any;
  IsChangeOwner: boolean = false;
  ReviewOwnerddlOptions: any[] = [];
  IsView: boolean = false;
  appCode: any;
  userType: string;
  setUpReviewForm: UntypedFormGroup;
  ApplicationID: any; 
  FilesListSelect: any [] = [];
  FilesListReference: any [] = [];
  SelectDocs: any[] = [];
  ApplicationRemoved: boolean = false;
  SelectedApplication: any;
  IsPlannedDateModified: boolean = false;
  PlannedEndDate: DateObject;
  CurrentDate: Date;
  ReferenceDocs: any[] = [];
  internalUsers: any[] = [];
  selectedUsers: any[]=[];
  ModuleID: any;
  disabledDates: Date [] = [];
  SubModule: any;
  userName: string;
  staticformFields:any;
  appStatus: any;
  appUsers: any;
  ProgramStartDate: Date; 
  minPStartDate = new Date();
  maxPStartDate: Date | undefined;
  minPEndDate = new Date();
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Planned_Date: DateObject; 
  user: any;
  type: any;
  uploadedFiles: any[] = [];
  minDate: Date;
  isReviewDocfromApp: boolean = false;

  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private userService: UserService,
    private reviewService: ReviewService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute
    ){}

  
  ngOnInit( ) {   
    this.minDate = new Date();
    if (this.Content.content !== null) {
      this.type = this.Content.content.type;
      this.ModuleID = this.Content.content.module;
      this.appId = this.Content.content.applicationId;
      this.appCode = this.Content.content.applicationCode;  
      this.appStatus = this.Content.content.applicationStatus;  
      if(this.Content.content.ReviewId!=null && this.Content.content.ReviewId!="" && this.Content.content.ReviewId!=undefined)
       {
           this.ReviewId = this.Content.content.ReviewId;
       }
       if(this.Content.content.IsChangeOwner!=null && this.Content.content.IsChangeOwner!="" && this.Content.content.IsChangeOwner!=undefined)
       {
           this.IsChangeOwner = this.Content.content.IsChangeOwner;
       }
      if (this.Content.heading != null && this.Content.heading != "" && this.Content.heading != undefined) {
        if (this.Content.heading == "View") {
           this.IsView = true;
        }
       }       
    }     

    if(this.type != "MyReviews"){
      this.GetApplicationDetails();
    }
    
  
    this.userType = this.userService.getUserType();

    if(this.Content.content.ReviewId!=null && this.Content.content.ReviewId!="" && this.Content.content.ReviewId!=undefined)
    {
      this.GetSetUpReviewDetailsById();           
    }
    else{
      this.GetOwner();
    }

    this.setUpReviewForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      Application_ID: new UntypedFormControl(null),
      Application_Code: new UntypedFormControl(null),
      Application_Status: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      PlannedEndDate: new UntypedFormControl(null),
      PlannedEndDateO: new UntypedFormControl(null),
      ReviewOwner: new UntypedFormControl(null),
      ReviewOwnerddl: new UntypedFormControl(null),
      ReviewOwnerName: new UntypedFormControl(null),
      ReviewStatus: new UntypedFormControl(null),
      ReviewDescription: new UntypedFormControl(null),
      //ActualStartDate: new UntypedFormControl(null),
      //ActualEndDate: new UntypedFormControl(null),
      Documents: new UntypedFormControl(null),
      ReferenceDocuments: new UntypedFormControl(null),    
      documaent_attach_list: new UntypedFormControl(null)    
    });
   
    
    this.setUpReviewForm.controls["ReviewStatus"].setValue("Pending");

    this.setUpReviewForm.controls["ReviewStatus"].disable();
    this.setUpReviewForm.controls["ReviewOwnerddl"].disable();

    //this.GetDocuments();
  }
  
  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }   

  GetSetUpReviewDetailsById() {

    this.ReviewOwnerddlOptions = [];
    let today = new Date(); today.setHours(0,0,0,0);
    this.reviewService.EditReview("api/Review/EditReview?Id=" + this.ReviewId).subscribe(result => {
      if (result) {
        this.setUpReviewForm.patchValue({
          PlannedEndDate:new Date(result["PlannedEndDate"])
        });
        this.setUpReviewForm.controls["Title"].setValue(result["Title"]); 

        this.CurrentDate = this.commonService.getdisplayedDate(result["PlannedEndDate"]);  
        let date = new Date(this.CurrentDate);
        while (date < today) {
          this.disabledDates.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
        setTimeout(() => {
          this.setUpReviewForm.controls["PlannedEndDate"].setValue(this.CurrentDate); 
        }, 0);        
        
        if(this.CurrentDate < today){
          this.minDate = this.CurrentDate;
        }
        
         this.setUpReviewForm.controls["ReviewStatus"].setValue(result["strReviewStatus"]);
         this.setUpReviewForm.controls["ReviewDescription"].setValue(result["ReviewDescription"]);

        if (result["isReviewDocfromApp"]) {
      //    this.SelectedApplication = (result["Documents"]);
          this.SelectDocs= result["Documents"];
        }
        else {
          this.SelectDocs = result["Documents"];
        }
        this.isReviewDocfromApp = result["isReviewDocfromApp"];
        this.ReferenceDocs = result["ReferenceDocuments"];
        this.selectedUsers = result["Reviewers"];
        this.ReviewOwnerddlOptions = result["lstusers"];
        this.ReviewOwnerddlOptions = [{ UserName: "Select", UserID: "", checked: true }].concat(this.ReviewOwnerddlOptions);
        if(this.IsChangeOwner || this.IsView)
          {             
            this.setUpReviewForm.controls["Title"].disable();
           // PlannedEndDateO: new UntypedFormControl(null),
            this.setUpReviewForm.controls["PlannedEndDate"].disable();
            this.setUpReviewForm.controls["ReviewOwner"].disable();
            if(this.IsView)
            {
            this.setUpReviewForm.controls["ReviewOwnerddl"].disable();
            }
            if(this.IsChangeOwner)
            {
            this.setUpReviewForm.controls["ReviewOwnerddl"].enable();
            }

            this.setUpReviewForm.controls["ReviewStatus"].disable();
            this.setUpReviewForm.controls["ReviewDescription"].disable();
          }
          this.setUpReviewForm.controls["ReviewOwnerddl"].setValue(result["ReviewOwner"]);
      }
    });
  }

  GetApplicationDetails(){
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {   
        this.ModuleID = this.commonService.getModuleId(params['module']);
        this.ApplicationID = this.commonService.appId;//params['id'];
        this.SubModule = params['submodule'];
      }
    });
  }

  GetOwner() {
    this.ReviewOwnerddlOptions=[];
    this.reviewService.GetOwner("api/Review/GetOwner?ApplicationID=" + this.appId + "&Module=" + this.ModuleID).subscribe(result => {
      if (result) {
        this.user = result;
        this.ReviewOwnerddlOptions=[{ UserName: this.user.UserName, UserID: this.user.UserID ,checked: true}];
        this.setUpReviewForm.controls["ReviewOwnerddl"].setValue(this.user.UserID);
        this.setUpReviewForm.controls["ReviewOwnerName"].setValue(this.user.UserName);
        
      }
    });
  }

  GetDocuments() {
    this.reviewService.GetDocuments("api/Review/GetDocuments?ApplicationID=" + this.appId + "&Module=" + this.ModuleID).subscribe(result => {
      if (result) {
        this.FilesListSelect = result["GetDocuments"];
        this.FilesListReference = result["GetReferenceDocuments"];
      }
    });
  }

  reviewDocuments(Type: string) {
    let files;
    let fileList;
    if(Type == "Select"){
      //files = this.FilesListSelect.filter(x=> x.FileName.match(/\.([^\.]+)$/)[1] == "docx" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "doc" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "ppt" ||  x.FileName.match(/\.([^\.]+)$/)[1] == "pptx");
      fileList = this.SelectDocs;
    } else{
      //files = this.FilesListReference;
      fileList = this.ReferenceDocs;
    }

    let modalRef = this.modalService.open(ReviewDocumentsModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg modal-dialog-center',
      animation: true
    });

    modalRef.componentInstance.Content = {
      fileList: files, DocType: Type, SelectedFiles: fileList,
      module: this.ModuleID, 
      subModule: this.SubModule, 
      ApplicationId: this.appId,
      Heading: this.Content.heading,
      isReviewDocfromApp: this.isReviewDocfromApp,
      ApplicationCode : this.appCode
    };
    modalRef.result.then(result => {
      if (Type == "Select") {
        this.isReviewDocfromApp = result.isAppchecked;
        if (this.isReviewDocfromApp) {                  // || this.SelectedApplication != null
          this.SelectDocs = [];
          result.selectedfiles.forEach(element => {
            element['Status'] = "Add"
            this.SelectDocs.push(element);
          });
          this.ReferenceDocs = [];
          this.reviewService.GetDocuments("api/Review/GetDocuments?ApplicationID=" +  this.appId + "&Module=" + this.ModuleID).subscribe(result1 => {
            if (result1["GetReferenceDocuments"] != null) {
              this.ReferenceDocs = result1["GetReferenceDocuments"];
              this.ReferenceDocs.forEach(file => {
                let ext = file.FileName.match(/\.([^\.]+)$/)[1];
                file.FileExt = ext;
              })
            }
           });
        }
        else {
         this.SelectDocs.forEach(file=>{
          if(file.isSelectedApplication) 
          {
            let index =result.selectedfiles.findIndex(x => x.FileID == file.FileID);
            this.SelectDocs.splice(index,1);
          }
         })
        result.selectedfiles.forEach(element => {
          this.SelectDocs.push(element); 
          this.isReviewDocfromApp = result.isAppchecked;
        });   
        }


      } else { 

        //Type = "Reference"
        result.selectedfiles.forEach(element => {
          this.ReferenceDocs.push(element); 
        });    
      }
    });
  }

  reviewContributors() {
    let modalRef = this.modalService.open(ReviewContributorsModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = {
      users: this.internalUsers, selectedUser: this.selectedUsers,
      module: this.ModuleID, subModule: this.SubModule, ApplicationId: this.appId 
    };
    modalRef.result.then((result) => {
      result.forEach(element => {
        this.selectedUsers.push(element); 
      });    
    });
  }

  
  CompareDates(oldDate: any, newDate: any): boolean {   
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }


  startDateSelect(event) {
   // this.minPEndDate = event;
    this.isStartDateModified = true;
    this.Planned_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23, 
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
 
  GetStartDate(): DateObject { 
    let formModel = this.setUpReviewForm.getRawValue();
    const lDate = new Date(formModel.PlannedEndDate);
    // const lDate = formModel.PROGRAM_START_DATE== null?null :  
    if ((this.CompareDates(this.CurrentDate, lDate) || this.Planned_Date == null || this.Planned_Date == undefined) &&
     formModel.PlannedEndDate != null) {
      this.Planned_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
         Minutes: 59,
         Seconds: 59,
         IsEndDate: true,
         HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Planned_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Planned_Date
  }

  save() {   
   
      if (!this.IsChangeOwner) {
        if (this.validateControls()) {   
        let formData = this.setUpReviewForm.value;
        formData["ID"]= this.ReviewId;
        formData["Application_ID"] = this.appId;
        formData["Application_Code"] = this.appCode;
        formData["Application_Status"] = this.appStatus;
        formData["ModuleID"] = this.ModuleID;
        formData["SubModule"] = this.SubModule;
        formData["Title"] = this.setUpReviewForm.controls["Title"].value;
        let planned = this.GetStartDate();
        formData["PlannedEndDate"] = this.setUpReviewForm.controls["PlannedEndDate"].value;
        formData["PlannedEndDateO"] = planned;
        formData["ReviewOwner"] = this.setUpReviewForm.controls["ReviewOwnerddl"].value;
        formData["ReviewOwnerName"] = this.setUpReviewForm.controls["ReviewOwnerName"].value;
        // formData["ReviewStatus"] = this.setUpReviewForm.controls["ReviewStatus"].value;
        formData["ReviewDescription"] = this.setUpReviewForm.controls["ReviewDescription"].value;
        formData["Documents"] = this.SelectDocs;
        formData["isReviewDocfromApp"] = this.isReviewDocfromApp;
        formData["ReferenceDocuments"] = this.ReferenceDocs;        
        formData["Reviewers"] = this.selectedUsers;

        let formData1 = new FormData();
        
        if (this.uploadedFiles != null && this.uploadedFiles.length > 0) {       
          for (let i = 0; i < this.uploadedFiles.length; i++) {        
              this.uploadedFiles[i].TRANSACTION_ID = ("" + (i + 1));
              formData1.append(("" + (i + 1)), this.uploadedFiles[i].File);
          }
        }
  
        formData1.append("ScreenData", JSON.stringify(formData));

        if (this.ReviewId == null || this.ReviewId == undefined || this.ReviewId == "") {
          this.reviewService.Insert("api/Review/Insert", formData1 ).subscribe(result => {
            if (result.Status == 0) {
              this.setUpReviewForm.controls["ID"].setValue(result.TransactionID);
              this.ReviewId = result.TransactionID;
              this.commonService.SuccessBanner(result.Message);
              this.modalRef.close(result);
             // this.GetDocuments();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          this.reviewService.Update("api/Review/Update", formData1).subscribe(result => {
            if (result.Status == 0) {
              this.setUpReviewForm.controls["ID"].setValue(result.TransactionID);
              this.ReviewId = result.TransactionID;
              this.commonService.SuccessBanner(result.Message);
              this.modalRef.close(result);
             // this.GetDocuments();
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
      }
      }
      else {
        var err: any = [];        
        if (!this.setUpReviewForm.controls["ReviewOwnerddl"].disabled &&  this.setUpReviewForm.controls["ReviewOwnerddl"].value == "") {
          err.push("Please select the Review Owner");
          this.commonService.ValidationBanner(err);
          return false;         
          }
        let formData = {
          "ID": this.ReviewId, "MODULE_ID": this.ModuleID, "Application_Code": this.appCode
          , "CurrentOwner": this.setUpReviewForm.controls["ReviewOwnerddl"].value, "GrantType": this.SubModule
        };
        this.reviewService.Changeowner_Review("api/Review/Changeowner_Review", formData).subscribe(result => {
          if (result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close(result);
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }
        });

      }    
  } 

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.setUpReviewForm.value;

    if (formData.Title === null || formData.Title === "" || formData.Title === undefined) {
      $("#Title").addClass("ng-touched ng-invalid validate-error");
      $("#Title").removeClass("ng-untouched ng-valid");
      message += `Please enter Review Title <br/>`
      isValid = false;
    } else {
      $("#Title").addClass("ng-untouched ng-valid");
      $("#Title").removeClass("ng-touched ng-invalid validate-error");
    }

    if(this.SelectDocs == undefined || this.SelectDocs.length <= 0)
    {
      message += `Please select atleast one document for review to save the details <br/>`
      isValid = false;
    }

    if (formData.PlannedEndDate === null || formData.PlannedEndDate === "") {
      $("#PlannedEndDate").addClass("ng-touched ng-invalid validate-error");
      $("#PlannedEndDate").removeClass("ng-untouched ng-valid");
      message += `Please select Planned end date <br/>`
      isValid = false;
    } else {
      $("#PlannedEndDate").addClass("ng-untouched ng-valid");
      $("#PlannedEndDate").removeClass("ng-touched ng-invalid validate-error");
    }

    // if(this.ReferenceDocs == undefined)
    // {
    //   message += `Please select Reference Documents <br/>`
    //   isValid = false;
    // }

    if(this.selectedUsers == undefined || this.selectedUsers.length <= 0)
    {
      message += `Please select atleast one reviewer to save the details <br/>`
      isValid = false;
    }

    // let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    // if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
    //   isValid = false;
    //   message = message + this.extendedForm.validateControlsMsgs();
    //   isValid = false;
    // }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }

  uploadchange(event): void {
    if (this.ReferenceDocs == undefined || this.ReferenceDocs == null) {
      this.ReferenceDocs = [];
    }
    let hasUnFormat = false;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new DocumentUploadFile();
      let file = event.target.files[i].name;   
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 10485760) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) 
      {
        hasUnFormat = true;
      }
      else 
      {
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.FileName = event.target.files[i].name;
        uploadFile.FileExt = ext;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";      
        this.ReferenceDocs.push(uploadFile);
        
        //uploadFile["FileID"] = uploadFile.ID;        
        this.uploadedFiles.push(uploadFile);
      }
    }

    if (hasUnFormat) {
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }

    // if(hasMultipleFiles){
    //   this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + " Please update the unique file name");
    // }
  }

  DeleteUpload(file): void {

    let index;
    index = this.SelectDocs.findIndex(x => x.FileID == file.FileID);
    this.SelectDocs.splice(index, 1);
    if (file.isSelectedApplication)  // while deleting Application isReviewDocfromApp should become false
      this.isReviewDocfromApp = false;
  }
  
  DeleteApplicationUpload(file): void {

    let index = this.SelectDocs.findIndex(x => x.FileID == file.FileID);
    this.SelectDocs.splice(index, 1);
   
  }

  DeleteRefereUpload(file): void {
    let index = this.ReferenceDocs.findIndex(x => x.FileID == (file.FileID != undefined )? file.FileID : file.ID);
    this.ReferenceDocs.splice(index, 1);  
    this.uploadedFiles.splice(index, 1);  
  }

  Delete(user): void {
    let findIndex = this.selectedUsers.findIndex(X=> X.UserID == user.UserID);
    if(findIndex != null){
      this.selectedUsers[findIndex].isSelected = false;
      this.selectedUsers.splice(findIndex, 1);
    }
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
}
